module.exports = __webpack_public_path__ + "img/attendee-phone-email.7fcbe100.jpg";